const initRentalCarRateOptionsManager = ()=>{
    const rentalCarRateCollections = {};
    return {
        getRentalCarByRateId: (rateId)=>rentalCarRateCollections[rateId],
        setRentalCarRates: (chatMessagesList)=>{
            const rentalCarRatesOptionsMarkers = chatMessagesList.filter((m)=>m?.displayComponentName === 'RENTAL_CAR_LISTING_MARKER' && m?.markerComponentProps);
            rentalCarRatesOptionsMarkers.forEach(({ markerComponentProps })=>{
                const { vehicles, finalRequestArgs } = markerComponentProps;
                vehicles.forEach((vehicle)=>{
                    vehicle.rate.forEach((rate)=>{
                        if (rate.rateId) rentalCarRateCollections[rate.rateId] = {
                            ...rate,
                            detailsInfo: {
                                ...vehicle,
                                rate: void 0
                            },
                            finalRequestArgs
                        };
                    });
                });
            });
        }
    };
};
const rentalCarRateOptionsManager = initRentalCarRateOptionsManager();
export { initRentalCarRateOptionsManager, rentalCarRateOptionsManager };
